import React, { useState } from 'react';
import styles from './productTable.module.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Uparrow, Downarrow, Leaf, Pdf } from '../../Svg';
import { toast } from 'react-toastify';
import { stripHtmlTags } from '../../utils/fomateDate';

const ProductTable = ({ products, handleAddtoSchedule }) => {
    const dispatch = useDispatch();
    const [quantities, setQuantities] = useState({});
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({});
    const [expandedProducts, setExpandedProducts] = useState({});
    
    const navigate = useNavigate();

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };

    const handleQuantityChange = (productId, value) => {
        setQuantities(prev => ({
            ...prev,
            [productId]: value
        }));
    };

    const handleAddClick = (productId, product) => {
        const quantity = quantities[productId] || '';
        if (!quantity) {
            toast.error('Please enter a quantity');
            return;
        }
        handleAddtoSchedule(productId, quantity, product);
    };

    const allAttributeKeys = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.attributes || {})))
    );

    const allEnvironmentalKeys = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.environmental || {})))
    );

    const allAdditionalResources = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.additionalResources || {})))
    );

    return (
        <div className={styles.productTableContainer}>
            <table className={styles.productTable}>
                <thead className={styles.productTableHead}>
                    <tr>
                        <th className={styles.compare}>Compare</th>
                        <th className={styles.dataSheet}>Data sheet</th>
                        <th className={styles.partNumber}>
                            <div className={styles.headerWithFilter}>
                                <span>Part </span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        <th className={styles.manufacturer}>
                            <div className={styles.headerWithFilter}>
                                <span>Manufacturer</span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        <th className={styles.stock}>
                            <div className={styles.headerWithFilter}>
                                <span>Available Stock</span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        <th className={styles.unitPrice}>Unit Price</th>
                        <th className={styles.requiredQuantity}>Required Quantity</th>

                        {allAttributeKeys?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                        {allEnvironmentalKeys?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                        {allAdditionalResources?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {products?.map((product, index) => {
                        const minMultiplier = product?.inventory?.minimumMultiplier || 1;
                        const quantity = quantities[product._id] || '';
                        
                        return (
                            <tr key={index}>
                                <td className={`${styles.compare}  ${styles.tdBorder}`}>
                                    <input type="checkbox" />
                                </td>
                                <td className={`${styles.dataSheet}  ${styles.tdBorder}`}>
                                    <div className={styles.dataCol}>
                                        <Pdf />
                                        <Leaf />
                                    </div>
                                </td>
                                <td className={`${styles.partNumber}  ${styles.tdBorder}`}>
                                    <div className={styles.dataRow}>
                                        <img src={product?.assets?.featuredImage[0]} style={{ width: 50, height: 50 }} />
                                        <div className={styles.dataCol}>
                                            <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${product?._id}`)} style={{ cursor: 'pointer' }}>
                                                {product?.productOverview?.productNumber[0]}
                                            </div>
                                            <div>{stripHtmlTags(product?.productOverview?.description?.[0] || product?.description)}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className={`${styles.manufacturer}  ${styles.tdBorder}`}>
                                    <a href={product.manufacturerUrl} className={styles.manufacturer}>
                                        <div className={styles.dataColorChange}>{product?.productOverview?.manufacturer[0]?.name}</div>
                                    </a>
                                </td>
                                <td className={`${styles.stock}  ${styles.tdBorder}`}>
                                    {product?.inventory?.qtyAvailable}
                                    <div className={styles.dataMargin}>in stock</div>
                                    {product?.inventory?.factoryStock && (
                                        <>
                                            {product?.inventory?.factoryStock}
                                            <div className={styles.dataMargin}>factoryStock</div>
                                        </>
                                    )}
                                    <div>CanShip Immediately: {product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</div>
                                </td>
                                <td className={`${styles.unitPrice} ${styles.tdBorder}`}>
                                    {product?.quantityTable
                                        ?.slice(
                                            0,
                                            expandedProducts[product?._id]
                                                ? product?.quantityTable?.length
                                                : 2
                                        )
                                        .map((i, index) => (
                                            <div key={index} className={styles.dataMargin}>
                                                {i?.breakQty}: <span style={{color:'#222222',fontWeight:700}}>₹{i?.unitPrice}</span>
                                                <div>{i?.packaging}</div>
                                            </div>
                                        ))}
                                    {product?.quantityTable?.length > 2 && (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleShowAll(product?._id);
                                            }}
                                        >
                                            <div className={styles.dataColorChange}>
                                                {expandedProducts[product?._id]
                                                    ? "Show Less"
                                                    : "More Inventory"}
                                            </div>
                                        </a>
                                    )}
                                </td>
                                <td className={`${styles.requiredQuantity}  ${styles.tdBorder}`}>
                                    <input
                                        type="number"
                                        placeholder="Enter qty"
                                        className={styles.dataInput}
                                        value={quantity}
                                        onChange={(e) => handleQuantityChange(product._id, e.target.value)}
                                        min="1"
                                        step={minMultiplier}
                                    />
                                    <div className={styles.dataMargin}>Min: {minMultiplier}</div>
                                    <div className={styles.dataMargin}>SPQ: {minMultiplier}</div>
                                    <div className={styles.dataCol}>
                                        <button
                                            className={styles.scheduleButton}
                                            disabled={!quantity || quantity <= 0}
                                            onClick={() => handleAddClick(product._id, product)}
                                            style={{ 
                                                cursor: 'pointer', 
                                                color: (!quantity || quantity <= 0) ? '#a284e6' : '#512DA8' 
                                            }}
                                        >
                                            {'+ Add to schedule'}
                                        </button>
                                    </div>
                                </td>
                                {allAttributeKeys?.map((key) => (
                                    <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                        {product.attributes[key]?.join(", ") || "N/A"}
                                    </td>
                                ))}
                                {allEnvironmentalKeys?.map((key) => (
                                    <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                        {product?.environmental[key]?.join(", ") || "N/A"}
                                    </td>
                                ))}
                                {allAdditionalResources?.map((key) => (
                                    <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                        {product?.additionalResources[key]?.join(", ") || "N/A"}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ProductTable;